export default "__VITE_ASSET__CnwIBaPX__"